import { useEffect, useSyncExternalStore } from 'react';
import { promotionApi } from '../api/promotionApi';
import { useAuth } from '../auth/useAuth';
import { useProfile } from '../context/ProfileContext';
import { getRememberedPromoCampaign, subscribeToPromoCampaign } from '../promoCampaign';

/**
 * Once a golfer who arrived through a promo link has signed in, records the campaign on their
 * account. The confirmation email often opens in a different browser than the one that scanned the
 * QR code, and that browser knows nothing about the offer; the account does. Repeating the call is
 * harmless, and a failure only means the offer stays with this browser.
 */
export function usePromoClaim(): void {
  const { isAuthenticated } = useAuth();
  const { profile, isHydrated, hasMembership } = useProfile();
  const claimed = profile.promoCampaign;
  // Read reactively: a golfer who is already signed in can accept the offer after their profile loaded.
  const slug = useSyncExternalStore(subscribeToPromoCampaign, getRememberedPromoCampaign);

  useEffect(() => {
    if (!isAuthenticated || !isHydrated || hasMembership || !slug || slug === claimed) return;
    promotionApi.claimCampaign(slug).catch(() => undefined);
  }, [isAuthenticated, isHydrated, hasMembership, claimed, slug]);
}
